import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText } = theme;

export const title = css`
  margin: 0;
  ${responsiveText.HEADING.MD};
`;
